import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\User\Auth\ForgotPasswordInertiaController::showLinkRequestForm
* @see app/Http/Controllers/User/Auth/ForgotPasswordInertiaController.php:13
* @route '/user/password/reset'
*/
export const showLinkRequestForm = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: showLinkRequestForm.url(options),
    method: 'get',
})

showLinkRequestForm.definition = {
    methods: ["get","head"],
    url: '/user/password/reset',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\User\Auth\ForgotPasswordInertiaController::showLinkRequestForm
* @see app/Http/Controllers/User/Auth/ForgotPasswordInertiaController.php:13
* @route '/user/password/reset'
*/
showLinkRequestForm.url = (options?: RouteQueryOptions) => {
    return showLinkRequestForm.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\User\Auth\ForgotPasswordInertiaController::showLinkRequestForm
* @see app/Http/Controllers/User/Auth/ForgotPasswordInertiaController.php:13
* @route '/user/password/reset'
*/
showLinkRequestForm.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: showLinkRequestForm.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\User\Auth\ForgotPasswordInertiaController::showLinkRequestForm
* @see app/Http/Controllers/User/Auth/ForgotPasswordInertiaController.php:13
* @route '/user/password/reset'
*/
showLinkRequestForm.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: showLinkRequestForm.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\User\Auth\ForgotPasswordInertiaController::showLinkRequestForm
* @see app/Http/Controllers/User/Auth/ForgotPasswordInertiaController.php:13
* @route '/user/password/reset'
*/
const showLinkRequestFormForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: showLinkRequestForm.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\User\Auth\ForgotPasswordInertiaController::showLinkRequestForm
* @see app/Http/Controllers/User/Auth/ForgotPasswordInertiaController.php:13
* @route '/user/password/reset'
*/
showLinkRequestFormForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: showLinkRequestForm.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\User\Auth\ForgotPasswordInertiaController::showLinkRequestForm
* @see app/Http/Controllers/User/Auth/ForgotPasswordInertiaController.php:13
* @route '/user/password/reset'
*/
showLinkRequestFormForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: showLinkRequestForm.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

showLinkRequestForm.form = showLinkRequestFormForm

/**
* @see \App\Http\Controllers\User\Auth\ForgotPasswordInertiaController::codeVerify
* @see app/Http/Controllers/User/Auth/ForgotPasswordInertiaController.php:22
* @route '/user/password/code-verify'
*/
export const codeVerify = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: codeVerify.url(options),
    method: 'get',
})

codeVerify.definition = {
    methods: ["get","head"],
    url: '/user/password/code-verify',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\User\Auth\ForgotPasswordInertiaController::codeVerify
* @see app/Http/Controllers/User/Auth/ForgotPasswordInertiaController.php:22
* @route '/user/password/code-verify'
*/
codeVerify.url = (options?: RouteQueryOptions) => {
    return codeVerify.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\User\Auth\ForgotPasswordInertiaController::codeVerify
* @see app/Http/Controllers/User/Auth/ForgotPasswordInertiaController.php:22
* @route '/user/password/code-verify'
*/
codeVerify.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: codeVerify.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\User\Auth\ForgotPasswordInertiaController::codeVerify
* @see app/Http/Controllers/User/Auth/ForgotPasswordInertiaController.php:22
* @route '/user/password/code-verify'
*/
codeVerify.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: codeVerify.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\User\Auth\ForgotPasswordInertiaController::codeVerify
* @see app/Http/Controllers/User/Auth/ForgotPasswordInertiaController.php:22
* @route '/user/password/code-verify'
*/
const codeVerifyForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: codeVerify.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\User\Auth\ForgotPasswordInertiaController::codeVerify
* @see app/Http/Controllers/User/Auth/ForgotPasswordInertiaController.php:22
* @route '/user/password/code-verify'
*/
codeVerifyForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: codeVerify.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\User\Auth\ForgotPasswordInertiaController::codeVerify
* @see app/Http/Controllers/User/Auth/ForgotPasswordInertiaController.php:22
* @route '/user/password/code-verify'
*/
codeVerifyForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: codeVerify.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

codeVerify.form = codeVerifyForm

const ForgotPasswordInertiaController = { showLinkRequestForm, codeVerify }

export default ForgotPasswordInertiaController